import PublicLayoutPages from "components/PublicLayoutPages/PublicLayoutPages";
import LogoSpinner from "components/Spinner/LogoSpinner";
import Accessories from "pages/Accessories/Accessories";
import Login from "pages/auth/Login/Login";
import Logout from "pages/auth/Logout/Logout";
import Console from "pages/Console/Console";
import DigitalServices from "pages/DigitalServices/DigitalServices";
import Desktops from "pages/Desktops/Desktops";
import { Error404 } from "pages/errors";
import Home from "pages/Home/Home";
import BookingNow from "pages/Laptops/BookingNow/BookingNow";
import Laptop from "pages/Laptops/Laptop/Laptop";
import Laptops from "pages/Laptops/Laptops";
import Offers from "pages/Laptops/Offers/Offers";
import Search from "pages/Laptops/Search/Search";
import MyCart from "pages/MyCart/MyCart";
import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
const Register = React.lazy(() => import("pages/auth/Register/Register"));
const ForgotMyPassword = React.lazy(() =>
  import("pages/auth/ForgotMyPassword/ForgotMyPassword")
);
const ContactUs = React.lazy(() => import("pages/ContactUs/ContactUs"));

const routes = [
  { url: "/", component: <Home /> },
  { url: "/login", component: <Login /> },
  { url: "/register", component: <Register /> },
  { url: "/logout", component: <Logout /> },
  { url: "/forgot-my-password", component: <ForgotMyPassword /> },
  { url: "/contact-us", component: <ContactUs /> },
  { url: "/laptops", component: <Laptops /> },

  { url: "/accessories", component: <Accessories /> },
  { url: "/accessories/:prand", component: <Accessories /> },

  { url: "/laptops/Offers", component: <Offers /> },
  { url: "/laptops/search", component: <Search /> },
  { url: "/laptops/:type", component: <Laptops /> },
  { url: "/laptops/:type/:prand", component: <Laptops /> },

  { url: "/product/:laptopId", component: <Laptop /> },

  { url: "/product/:laptopId/booking", component: <BookingNow /> },

  { url: "/my-cart", component: <MyCart /> },
  { url: "/desktops", component: <Desktops /> },
  { url: "/console", component: <Console /> },
  { url: "/console/:prand", component: <Console /> },
  { url: "/digital-services", component: <DigitalServices /> },
];

const ClientRoutes = () => {
  // دالة لتحقق من الصلاحية وإرجاع المسار
  const makeRoute = ({ url, component }) => {
    return (
      <Route
        key={url}
        path={url}
        element={
          <Suspense fallback={<LogoSpinner page />}>{component}</Suspense>
        }
      />
    );
  };

  return (
    <Routes>
      <Route element={<PublicLayoutPages />}>
        {routes.map(makeRoute)}
        {/* <Route
          path="/not-authorized"
          element={<Error401 navigateTo={"/"} timer={10000} />}
        /> */}
        <Route path="*" element={<Error404 navigateTo={"/"} timer={10000} />} />
      </Route>
    </Routes>
  );
};

export default ClientRoutes;
